import {Component, h} from "preact";
import {Card, CF, E, FR} from "../../_common/layout";
import {t} from "../../_i18n";
import {Form as FinalForm} from "react-final-form";
import {FormField} from "../../_common/forms/components/components";
import {ButtonLink, ButtonPrimary} from "../../_common/components/buttons/buttons";
import {fetchStudent, saveStudent} from "../../_rx/student/actions";
import {AppPage} from "../../_common/components/app-page";
import {connect} from "react-redux";

let SocialSecurityNumberView = class extends Component {

    componentDidMount() {
        const {auth} = this.props;
        this.props.fetchStudent(auth.loggedUser.id);
    }

    onSubmit(data){
        console.log(data)
        return this.props.saveStudent(data).catch(err=> ({'error': true}));
    }

    handleCancel(e){
        e.preventDefault()
        this.props.history.goBack()
    }

    render({student, history}) {
        return student &&
            <CF className="max-width m-top-header-xs-sm">
                <Card className="p-bottom">
                    <h1>{t('Cambiar Número de Afiliación de la Seguridad Social')}</h1>
                    <FinalForm onSubmit={data=>this.onSubmit(data)} initialValues={student} render = {
                        ({handleSubmit,  submitting, errors, submitSucceeded})=>
                            <form className='form' action="" onSubmit={handleSubmit} noValidate>
                                {submitSucceeded && history.goBack()}
                                <FR><E className='m-top sm-no-m-top col-100 sm-col-60'>
                                    <FormField name="data.social_security" label={t('Número Seguridad Social')} type="text" required={true} />
                                </E></FR>
                                <FR className='m-top'>
                                    <E className='full-width sm-no-full-width'>
                                        <ButtonPrimary className="full-width sm-no-full-width" type='submit'>{t('Guardar')}</ButtonPrimary>
                                    </E>
                                    <E>
                                        <ButtonLink className="full-width sm-no-full-width sm-d-block d-none" onClick={(e) => this.handleCancel(e)}>{t('Cancelar')}</ButtonLink>
                                    </E>
                                </FR>
                            </form>
                    }
                    />
                </Card></CF>;
    }
};


SocialSecurityNumberView = connect(
    ({auth, student}) => ({auth, student}),
    {
        fetchStudent,
        saveStudent
    })(SocialSecurityNumberView);

const SocialSecurityNumber = ({history}) =>
    <AppPage
        name="numero-seguridad-social"
        className="max-width"
    >
        <SocialSecurityNumberView history={history}/>
    </AppPage>
;

export default SocialSecurityNumber;
